import PropTypes from 'prop-types'
import React from 'react'
import titleize from 'titleize'
import get from 'lodash-es/get'
import humanizeString from 'humanize-string'

import SearchLink from '../../../../shared/containers/searchLinkContainer'
import filterParamsConfig from '../../../../../common/constants/filterParamsConfig'
import ArrowFillRightIcon from '../../../../shared/components/icons/arrowFillRight'

const PanelHeader = props => {
  const {
    togglePanel,
    locationParams,
    rootCount,
    type,
    breadcrumbsLabel
  } = props

  const chosenOption = locationParams[type] || ''
  const delimiter = get(filterParamsConfig, `${type}.delimiter`)
  const chosenOptionArray = chosenOption.split(delimiter)
  const chosenOptionLength = chosenOptionArray.length
  const chosenOptionDisplayName = titleize(
    humanizeString(chosenOptionArray[chosenOptionLength - 1])
  )

  let BreadLinks = []
  for (let i = 0; i < chosenOptionLength; i++) {
    // return empty link for last item
    if (i === chosenOptionLength - 1) {
      BreadLinks.push(
        <a href="" key={i} className="is-last">
          <ArrowFillRightIcon
            width="9"
            height="13"
            className="breadcrumbs__icon"
          />
          {chosenOptionDisplayName}
        </a>
      )
    } else {
      let newQuery = Object.assign({}, locationParams)
      newQuery[type] = chosenOption.substring(
        0,
        chosenOption.indexOf(chosenOptionArray[i]) + chosenOptionArray[i].length
      )
      delete newQuery.page
      BreadLinks.push(
        <SearchLink
          locationParams={newQuery}
          onClick={togglePanel}
          key={i}
          rel="nofollow"
        >
          <ArrowFillRightIcon
            width="9"
            height="13"
            className="breadcrumbs__icon"
          />
          {titleize(humanizeString(chosenOptionArray[i]))}
        </SearchLink>
      )
    }
  }

  // top level option link
  let rootQuery = Object.assign({}, locationParams)
  delete rootQuery[type]

  return (
    <div className="search-facet-panel__breadcrumbs-wrapper">
      <div className="search-facet-panel__breadcrumbs-intro">
        <span className="fds-c-text-body -size-s">Show:</span>
      </div>
      <div className="search-facet-panel__breadcrumbs">
        <nav className="breadcrumbs -line-wrap -color-grey -icon-fill fds-u-text-truncate">
          <SearchLink
            locationParams={rootQuery}
            onClick={togglePanel}
            rel="nofollow"
          >
            All {breadcrumbsLabel}
            <span className="breadcrumbs__count">{rootCount}</span>
          </SearchLink>
          {BreadLinks}
        </nav>
      </div>
    </div>
  )
}

PanelHeader.propTypes = {
  togglePanel: PropTypes.func.isRequired,
  locationParams: PropTypes.object.isRequired,
  rootCount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  breadcrumbsLabel: PropTypes.string.isRequired
}

export default PanelHeader
